export default "__VITE_ASSET__Dbytw2iC__"